<template>
  <v-container fluid>
    <v-row class="ma-0">
      <v-card width="100%" min-height="400px" height="100%" class="flex-card">
        <v-card-title>Produtores sem acesso</v-card-title>
        <v-divider />
        <v-container fluid class="p-relative flex-fill">
          <v-row class="ma-0" align="start">
            <v-col v-for="(item, idx) in items" :key="idx" cols="12">
              <producer-without-access-item
                :index="idx"
                :item="item"
                :producers="producers"
                :technical-managers="technicalManagers"
                @delete="onDeleteItem"
                @save="onSaveItem"
              />
            </v-col>
          </v-row>
          <v-btn absolute top right fab color="success" @click="onAddClick">
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </v-container>
      </v-card>
    </v-row>
  </v-container>
</template>

<script lang="js">
import ProducerWithoutAccessItem from "@/modules/ProducersWithoutAccess/components/ProducerWithoutAccessItem"
import {URLS} from "@/modules/ProducersWithoutAccess/api/urls"

const defaultItemState = () => ({
  idProdutorSemAcesso: null,
  nmProdutor: null,
  strMotivo: null,
  cdResponsavelTecnico: null
})

const SETTLEMENT_API = process.env.VUE_APP_URL_API_ESTABELECIMENTO
export default {
  name: "ProducersWithoutAccess",
  components: {ProducerWithoutAccessItem},
  data: () => ({
    items: [],
    producers: [],
    technicalManagers: []
  }),
  methods: {
    onAddClick() {
      this.items.push(defaultItemState())
    },
    onSaveItem(toSave) {
      const {index, item} = toSave
      this.items.splice(index, 1, item)
    },
    onDeleteItem(toDelete) {
      const {index} = toDelete
      this.items.splice(index, 1)
    },
    //Helpers
    loadProducersWithoutAccess() {
      this.$axios
        .get(URLS.PRODUCERS_WITHOUT_ACCESS)
        .then(res => {
          if (!res.data) return
          if (!res.data[0]) return
          if (!res.data[0].data) return
          console.log(res.data[0].data)
          this.items = res.data[0].data
        })
    },
    loadProducers() {
      const finalUrl = new URL("produtor/", SETTLEMENT_API)
      this.$axios.get(finalUrl.toString())
        .then(res => {
          this.producers = res.data
        })
    },
    loadTechnicalManagers() {
      this.$axios
        .get('responsavel-tecnico/')
        .then(res => {
          if (!res.data) return
          if (!res.data[0]) return
          if (!res.data[0].data) return
          this.technicalManagers = res.data[0].data
        })
    }
  },
  mounted() {
    this.loadProducersWithoutAccess()
    this.loadProducers()
    this.loadTechnicalManagers()
  }
}
</script>

<style scoped lang="scss">
.p-relative {
  position: relative;
}

.flex-card {
  display: flex;
  flex-direction: column;
}
</style>
